export default __webpack_public_path__ + "static/media/edit-white.945756bf.svg";